import { Injectable } from '@angular/core';

@Injectable()
export class ImageViewerService {
  images = [];
  activeIndex;

  setImages(images, index = 0) {
    this.images = images;
    this.activeIndex = index;
  }

  clear() {
    this.images = [];
  }

  isNextAvailable() {
    return this.activeIndex + 1 < this.images.length;
  }

  isPrevAvailable() {
    return this.activeIndex > 0;
  }

  showNext() {
    if (this.isNextAvailable()) {
      this.activeIndex = this.activeIndex + 1;
    }
  }

  showPrev() {
    if (this.isPrevAvailable()) {
      this.activeIndex = this.activeIndex - 1;
    }
  }
}
